<template>
  <slick :options="slickOptions" v-if="!isBusy">
    <template v-for="(item, i) in galleryArtistRecentArts">
      <article
        class="item"
        :key="i"
        @click="onClickArtwork(item.idx)"
        v-if="item.idx !== artwork"
      >
        <v-lazy :options="{ threshold: 0.5 }" transition="fade-transition">
          <div class="img-box" @contextmenu.prevent.stop>
            <b-img
              :style="{
                display: isProductFileTypeImage(item.displayCard)
                  ? 'block'
                  : 'none',
              }"
              :src="replaceThumbnailUrlV2(item)"
            >
            </b-img>
            <video
              :style="{
                display: isProductFileTypeImage(item.displayCard)
                  ? 'none'
                  : 'block',
              }"
              :poster="replaceThumbnailUrlV2(item)"
              :src="replaceVideoThumbnailUrl(item)"
              type="video/webm"
              muted
              loop
              autoplay
              playsinline
            ></video>
          </div>
        </v-lazy>
        <section class="card-info">
          <section class="card-info__header" v-if="!isBusy">
            <p class="name" @click.stop="onClickArtist">
              <template
                v-if="activeLanguage !== undefined && activeLanguage === 'ko'"
              >
                {{ item.artistName || item.artistNameEn }}
              </template>
              <template v-else>
                {{ item.artistNameEn || item.artistName }}
              </template>
            </p>

            <FavoritedButton
              :favoritedItem="item"
              @onClickFavoritedButton="onClickFavoritedButton"
            />
          </section>
          <section class="card-info__header" v-else>
            <p class="artist_name">
              <b-skeleton
                type="avatar"
                height="30px"
                width="30px"
                class="float-left"
              ></b-skeleton>
              <b-skeleton
                class="float-left mt-2 ml-2"
                width="100px"
              ></b-skeleton>
            </p>
          </section>
          <h3 class="card-info__title">
            <template
              v-if="activeLanguage !== undefined && activeLanguage === 'ko'"
            >
              {{ item.productName || item.productNameEn }}
            </template>
            <template v-else>
              {{ item.productNameEn || item.productName }}
            </template>
          </h3>
          <section class="card-info__price" v-if="!isBusy">
            <p class="price-label">price</p>
            <p
              class="price-value"
              :class="{
                soldout:
                  item.status === 'SOLDOUT' || item.status === 'PRIVATESOLD',
              }"
            >
              <template
                v-if="
                  item.status === 'SOLDOUT' || item.status === 'PRIVATESOLD'
                "
              >
                {{
                  item.buyerNickname !== undefined && item.buyerNickname !== ""
                    ? "Owned by @" + item.buyerNickname
                    : $t("product.statusSoldOut")
                }}
              </template>
              <template v-else-if="item.status === 'EXHIBIT'">
                {{ $t("product.statusExhibit") }}
              </template>
              <template
                v-else-if="
                  item.nftType === 'ORDINALS' &&
                  activeLanguage !== undefined &&
                  activeLanguage === 'en'
                "
              >
                {{ getSatoshiToBtc(item.productCoinPrice) }}
                {{ getCoinCurrencyByNftType(item.nftType) }}
              </template>
              <template v-else-if="item.nftType === 'ORDINALS'">
                {{ getSatoshiToKRW(item.productCoinPrice) }} KRW
              </template>
              <template
                v-else-if="
                  activeLanguage !== undefined &&
                  activeLanguage === 'en' &&
                  isCoinPriceNonZero(item.nftType) &&
                  isAcceptableNftType(item.nftType)
                "
              >
                {{ getProductCoinPrice(item.productPrice, item.nftType) }}
                {{ getCoinCurrencyByNftType(item.nftType) }}
              </template>
              <template v-else>
                {{ item.productPrice | currency }}
                {{
                  item.productPrice !== undefined && item.productPrice > 0
                    ? "KRW"
                    : $t("product.statusExhibit")
                }}
              </template>
            </p>
          </section>
          <section class="card-info__price" v-else>
            <span>
              <b-skeleton width="50%" height="25px"></b-skeleton>
            </span>
          </section>
        </section>
      </article>
    </template>
  </slick>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import coinUtils from "@/mixins/CoinUtils";
import FavoritedButton from "@/views/threespace/components/common/FavoritedButton";

export default {
  name: "ArtworkArtList",
  components: {
    Slick,
    FavoritedButton,
  },
  data() {
    return {
      isBusy: false,
      artwork: 0,
      idxArtistMember: 0,
      slickOptions: {
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        centerPadding: "23px",
        autoplay: false,
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              arrows: false,
              dots: false,
              infinite: false,
              slidesToShow: 5,
              slidesToScroll: 1,
              autoplay: false,
            },
          },
          {
            breakpoint: 960,
            settings: {
              arrows: false,
              dots: false,
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              autoplay: false,
            },
          },
          {
            breakpoint: 680,
            settings: {
              arrows: false,
              dots: false,
              infinite: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              autoplay: false,
            },
          },
          {
            breakpoint: 540,
            settings: {
              arrows: false,
              dots: false,
              infinite: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              autoplay: false,
            },
          },
        ],
      },
    };
  },
  mixins: [coinUtils],
  computed: {
    ...mapState("gallery", ["galleryArtistRecentArts"]),
    activeLanguage() {
      return this.getActiveLanguage();
    },
  },
  methods: {
    ...mapActions("gallery", ["getGalleryArtistRecentArts"]),
    ...mapActions("auth", ["verifyTokenCallback"]),
    requestArtistRecentArts(idxArtist, idxCurrentArtwork, idxArtistMember) {
      this.artwork = idxCurrentArtwork;
      this.idxArtistMember = idxArtistMember;
      this.isBusy = true;
      this.getGalleryArtistRecentArts(idxArtist)
        .then(() => {
          this.isBusy = false;
        })
        .catch((error) => {
          this.isBusy = false;
          this.$log.error(error);
        });
    },
    isProductFileTypeImage(_productFileType) {
      return (
        _productFileType !== undefined && _productFileType.startsWith("image")
      );
    },
    onClickArtist() {
      let idxEncode = window.btoa(this.idxArtistMember);
      this.$router.push("/collections/" + idxEncode);
    },
    onClickArtwork(idx) {
      this.$router.push("/art/" + idx);
    },
    getActiveLanguage() {
      return localStorage.getItem("language") || "en";
    },
    onClickFavoritedButton(favoritedItem) {
      if (this.isAuthenticated) {
        this.verifyTokenCallback().then(() => {
          if (
            this.me === undefined ||
            this.me === null ||
            this.me.idx === undefined ||
            this.me.idx === null ||
            this.me.idx === ""
          ) {
            // 로그인
            this.hasKlaytnAddr = false;
            this.$store.commit("setCommonAlertModalInfo", {
              msgHtml: this.$t("validation.requiredLogin"),
              show: true,
              fontSize: "sm",
            });
          } else {
            // 로그인 되어있음
            if (favoritedItem.favorited) {
              // true이면 좋아요 헤재
              this.toggleFavorited(favoritedItem);
              this.deleteFavorited({ idxCollection: favoritedItem.idx });
            } else {
              // false이면 좋아요
              this.toggleFavorited(favoritedItem);
              this.addFavorited({ idxCollection: favoritedItem.idx });
            }
          }
        });
      } else {
        this.$store.commit("setCommonAlertModalInfo", {
          msgHtml: this.$t("validation.requiredLogin"),
          show: true,
          fontSize: "sm",
        });
      }
    },
    replaceDisplayCardUrl(item) {
      if (
        item.displayCardFile !== undefined &&
        item.displayCardFile !== null &&
        item.displayCardFile !== "" &&
        item.displayCardFile === "THREESPACE"
      ) {
        return item.displayCardUrlThreespace; // 3space S3 URL
      } else {
        if (
          item.displayCardUrl !== undefined &&
          item.displayCardUrl.startsWith("https://ipfs.io/")
        ) {
          return item.displayCardUrl.replace(
            "https://ipfs.io/",
            "https://ipfs.3space.art/"
          );
        }
        return item.displayCardUrl;
      }
    },
    replaceThumbnailUrl(item) {
      const w = "400";
      const h = "463";
      const thumbnailUrl = `https://collection.3space.art/${process.env.NODE_ENV}/${item.idx}.jpg`;
      if (
        item.displayPoster !== undefined &&
        item.displayPoster !== null &&
        item.displayPoster !== "" &&
        item.displayPoster === "THREESPACE"
      ) {
        return `${thumbnailUrl}?src=${item.displayPosterUrlThreespace}&w=${w}&h=${h}`; // 3space S3 URL
      } else {
        if (
          item.displayPosterUrl !== undefined &&
          item.displayPosterUrl.startsWith("https://ipfs.io/")
        ) {
          item.displayPosterUrl = item.displayPosterUrl.replace(
            "https://ipfs.io/",
            "https://ipfs.3space.art/"
          );
        }
        return `${thumbnailUrl}?src=${item.displayPosterUrl}&w=${w}&h=${h}`;
      }
    },
    replaceThumbnailUrlV2(item) {
      if(item.thumbnail) {
        return item.thumbnailUrl;
      } else {
        return this.replaceThumbnailUrl(item);
      }
    },
    hasVideoThumbnail(item) {
      if(item.thumbnailOriginal) return true;
      if(item.thumbnailPreview) return true;

      return false;
    },
    replaceVideoThumbnailUrl(item) {
      if(item.thumbnailOriginal) return item.thumbnailOriginalUrl;
      if(item.thumbnailPreview) return item.thumbnailPreviewUrl;

      return this.replaceDisplayCardUrl(item);
    },
  },
};
</script>
